

import React, { useState } from "react";
import { Line } from "react-chartjs-2"; // Import Chart.js
import { Modal } from "react-bootstrap"; // For the popup modal
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// Sample data for the applicant
const sampleApplicantData = {
  name: "Aman", // Name
  posts: [
    {
      mediaId: "18122162965378114",
      mediaType: "IMAGE",
      mediaUrl: "https://i.postimg.cc/SxtScLJs/483985964-17844031209441750-8810113307264106474-n.jpg",
      likes: 1,
      commentsCount: 0,
      metrics: {
        likes: [{ value: 1 }],
        comments: [{ value: 0 }],
        reach: [{ value: 0 }],
        impressions: [{ value: 0 }],
      },
    },
  ],
};

const ApplicantPostsMetrics = () => {
  const [applicantData, setApplicantData] = useState(sampleApplicantData);
  const [showChartModal, setShowChartModal] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);

  // Chart data preparation
  const getChartData = (postMetrics) => {
    return {
      labels: ["Likes", "Comments", "Reach", "Impressions"],
      datasets: [
        {
          label: "Metrics",
          data: [
            postMetrics.likes[0].value,
            postMetrics.comments[0].value,
            postMetrics.reach[0].value,
            postMetrics.impressions[0].value,
          ],
          fill: false,
          backgroundColor: "rgba(75,192,192,1)",
          borderColor: "rgba(75,192,192,1)",
        },
      ],
    };
  };

  // Handle modal toggle (show or hide)
  const handleToggleChartModal = (post) => {
    if (selectedPost && selectedPost.mediaId === post.mediaId) {
      // If the same post is clicked again, close the modal
      setShowChartModal(false);
      setSelectedPost(null);
    } else {
      // Otherwise, show the modal with the new post
      setSelectedPost(post);
      setShowChartModal(true);
    }
  };

  return (
    <div className="applicant-metrics">
      {/* Title centered and in bold */}
      <div className="text-center font-bold text-3xl mb-6">
        Applicant Metrics - {applicantData.name}
      </div>

      <div className="posts">
        <h3>Posts</h3>
        {applicantData.posts.length > 0 ? (
          applicantData.posts.map((post) => (
            <div key={post.mediaId} className="post-item">
              <img
                src={post.mediaUrl}
                alt="Post"
                style={{ width: "300px", height: "300px" }}
                onClick={() => handleToggleChartModal(post)} // Open modal when image is clicked
              />
              <div>
                <p>Likes: {post.likes}</p>
                <p>Comments: {post.commentsCount}</p>
              </div>

              {/* Small up arrow icon */}
              <button
                style={{
                  border: "none",
                  background: "none",
                  cursor: "pointer",
                  fontSize: "24px",
                  color: "#007bff",
                }}
                onClick={() => handleToggleChartModal(post)}
              >
                ↑ View Metrics
              </button>
            </div>
          ))
        ) : (
          <p>No posts available.</p>
        )}
      </div>

      {/* Modal for showing the chart */}
      {selectedPost && (
        <Modal
          show={showChartModal}
          onHide={() => setShowChartModal(false)}
          size="sm" // Make the modal smaller
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Post Metrics for {selectedPost.mediaId}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>Metrics Overview</h4>
            {/* Small chart for metrics */}
            <div style={{ height: "200px", width: "100%" }}>
              <Line
                data={getChartData(selectedPost.metrics)}
                options={{
                  responsive: true,
                  maintainAspectRatio: false, // Allow resizing of the chart
                  plugins: {
                    legend: {
                      display: false, // Hide legend for small chart
                    },
                  },
                  scales: {
                    y: {
                      beginAtZero: true, // Start the y-axis from zero
                    },
                  },
                }}
              />
            </div>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
};

export default ApplicantPostsMetrics;
